// extracted by mini-css-extract-plugin
export default {"navTabItem":"_50f2ed1e","navTabLink":"_a867866b","active":"_295e07e9","panelsWrapper":"_20a38673"};